import { type FC } from 'react'

import { HOMEPAGE_GPT_ID } from '@/components-page/homepage/advertisement/homepageAdSlots'
import { StyledGptTakeover } from '@/components-page/homepage/advertisement/styled'

export const GptTakeover: FC = () => (
  <StyledGptTakeover id={HOMEPAGE_GPT_ID.TAKEOVER} data-testid="gpt-takeover-homepage" />
)
